export default __webpack_public_path__ + "static/Handling-68627061b6228e399733d0f44c51faf2.jpg";